import React from "react";
import { Alert, Button } from "antd";
import DynamicTable from "../../../components/DynamicTable";
import { rupees } from "../formatters";

function PaymentsTable({ data, page, setPage, saving, reconcile, onRefund }) {
  return (
    <>
      <Alert
        type="info"
        message="Wallet refunds return paid money to the wallet and restore promotional credit separately. Initiate UPI refunds in Razorpay, then reconcile here; this screen does not send a second bank refund."
      />
      <DynamicTable
        showAction={false}
        rowKey="id"
        dataSource={data.checkouts}
        scroll={{
          x: 1100,
        }}
        pagination={{
          current: page + 1,
          pageSize: 50,
          total: data.checkout_count,
          showSizeChanger: false,
          onChange: (p) => setPage(p - 1),
        }}
        columns={[
          {
            title: "Checkout",
            dataIndex: "id",
          },
          {
            title: "Student",
            dataIndex: "user_id",
          },
          {
            title: "Ride",
            dataIndex: "ride_id",
          },
          {
            title: "Method",
            dataIndex: "method",
          },
          {
            title: "State",
            dataIndex: "state",
          },
          {
            title: "Paid amount",
            dataIndex: "cash_paise",
            render: rupees,
          },
          {
            title: "Credit used",
            dataIndex: "promo_paise",
            render: rupees,
          },
          {
            title: "Cash refunded",
            dataIndex: "result.refunded_cash_paise",
            render: (_, row) => rupees(row.result?.refunded_cash_paise),
          },
          {
            title: "Action",
            dataIndex: "action",
            render: (_, row) =>
              row.method === "upi" ? (
                <Button loading={saving} onClick={() => reconcile(row)}>
                  Reconcile
                </Button>
              ) : row.method === "wallet" &&
                ["paid", "refunded"].includes(row.state) ? (
                <Button
                  onClick={() => {
                    onRefund(row);
                  }}
                >
                  Refund
                </Button>
              ) : null,
          },
        ]}
      />
    </>
  );
}
export default PaymentsTable;
